__turbopack_context__.v({
  "dropdownMenu": "index-module-scss-module__fcy4dW__dropdownMenu",
});
